import * as types from './types';

export const setSelectedTab = value => {
  return {
    type: types.KITCHEN_PREP_SET_SELECTED_TAB,
    payload: value,
  };
};



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/settings/actions.js